import React, { Component } from "react";

const LaundryIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9041 0H3.76255C2.79067 0 2 0.790667 2 1.76255V20H18.6667V1.76255C18.6667 0.790667 17.876 0 16.9041 0V0ZM3.76255 1.17647H10.2353V2.99361C10.2353 3.28906 9.99494 3.52941 9.69949 3.52941H7.88235V2.35294H6.70588V3.52941H5.52941V2.35294H4.35294V3.52941H3.17647V1.76255C3.17647 1.43937 3.43937 1.17647 3.76255 1.17647ZM3.17647 18.8235V4.70588H9.69949C10.6436 4.70588 11.4118 3.93776 11.4118 2.99361V1.17647H16.9041C17.2273 1.17647 17.4902 1.43937 17.4902 1.76255V8.23529H14.9382C13.8639 6.80745 12.1556 5.88235 10.2353 5.88235C6.99177 5.88235 4.35294 8.52118 4.35294 11.7647C4.35294 15.0082 6.99177 17.6471 10.2353 17.6471C12.1556 17.6471 13.8639 16.722 14.9382 15.2941H17.4902V18.8235H3.17647ZM14.9412 11.7647C14.9412 14.3595 12.8301 16.4706 10.2353 16.4706C7.64047 16.4706 5.52941 14.3595 5.52941 11.7647C5.52941 9.16988 7.64047 7.05882 10.2353 7.05882C12.8301 7.05882 14.9412 9.16988 14.9412 11.7647ZM15.626 9.41177H17.4902V14.1176H15.626C15.9419 13.3967 16.1176 12.6009 16.1176 11.7647C16.1176 10.9285 15.9419 10.1327 15.626 9.41177Z"
        fill={fill}
      />
      <path
        d="M10.2352 8.23535C8.28911 8.23535 6.70581 9.81865 6.70581 11.7648C6.70581 13.7109 8.28911 15.2942 10.2352 15.2942C12.1814 15.2942 13.7646 13.7109 13.7646 11.7648C13.7646 9.81865 12.1814 8.23535 10.2352 8.23535ZM10.2352 9.41182C11.4108 9.41182 12.3878 10.2785 12.5609 11.4064C11.921 11.6661 11.2025 11.609 10.607 11.2425C9.84244 10.772 8.93032 10.6322 8.07346 10.8366C8.43425 9.99947 9.26731 9.41182 10.2352 9.41182ZM10.2352 14.1177C9.06346 14.1177 8.08922 13.2566 7.9115 12.1341L7.96726 12.1093C8.62291 11.8178 9.37927 11.8684 9.99044 12.2445C10.5307 12.577 11.1367 12.7445 11.745 12.7445C11.9652 12.7445 12.1857 12.7224 12.4035 12.6783C12.0462 13.5233 11.2088 14.1177 10.2352 14.1177Z"
        fill={fill}
      />
      <path d="M12.5881 2.35303H16.1176V3.5295H12.5881V2.35303Z" fill={fill} />
    </svg>
  );
};

LaundryIcon.defaultProps = {
  width: 20,
  height: 20,
  fill: "black",
};

export default LaundryIcon;
